import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './wysiwyg.css';
import './render.css';
import classNames from 'classnames';

// @example
// <Markdown content='I'm some **markdown** text' />
//
// @docs
// https://github.com/remarkjs/react-markdown

interface MarkdownProps {
  linkClassName?: string;
  className?: string;
  content: string;
  defaultStyles?: boolean;
}

function Markdown({ linkClassName, className, content, defaultStyles = true, ...rest }: MarkdownProps) {
  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      className={classNames(defaultStyles && 'wysiwyg', className)}
      components={{
        a: ({ children, ...props }) => (
          <a
            className={linkClassName}
            target="_blank"
            rel="noopener noreferrer"
            data-durable-id="markdownLinkId"
            data-intercom-target="markdownLinkId"
            {...props}
          >
            {children}
          </a>
        ),
      }}
      {...rest}
    >
      {content}
    </ReactMarkdown>
  );
}

export default Markdown;
